import { useState } from "react";
import { FC } from "react";
import { createPortal } from "react-dom";
import { usePopper } from "react-popper";
import { ChevronLeft, ChevronRight } from "shared/assets/icons";

import { CalendarPickerDropdown, IconButton, Overlay } from "shared/components";
import { months } from "shared/constants";
import { IDate } from "shared/types";
import { CalendarPickerContainer, CalendarPickerTrigger } from "./styles";

interface CalendarPickerProps {
  date: IDate;
  setDate: (date: IDate) => void;
}

export const CalendarPicker: FC<CalendarPickerProps> = ({ date, setDate }) => {
  const { month, year } = date;
  const [isOpen, setIsOpen] = useState(false);

  const handleNextButton = () => {
    if (month < 11) {
      setDate({ year, month: month + 1 });
    } else {
      setDate({ year: year + 1, month: 0 });
    }
  };
  const handlePreviousButton = () => {
    if (month > 0) {
      setDate({ year, month: month - 1 });
    } else {
      setDate({ year: year - 1, month: 11 });
    }
  };

  const [referenceElement, setReferenceElement] = useState<HTMLDivElement | null>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(null);
  const { styles } = usePopper(referenceElement, popperElement, {
    placement: "bottom-start",
    strategy: "fixed",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 8],
        },
      },
    ],
  });

  const handleSubmitDate = (date: IDate) => {
    setDate(date);
    setIsOpen(false);
  };

  return (
    <CalendarPickerContainer ref={setReferenceElement}>
      <IconButton label="previous" icon={ChevronLeft} onClick={handlePreviousButton} />
      <CalendarPickerTrigger
        label={`${months[month]} ${year}`}
        isOpen={isOpen}
        handleClick={() => setIsOpen(!isOpen)}
        hideContainer={true}
      />
      <IconButton label="next" icon={ChevronRight} onClick={handleNextButton} />
      {isOpen && (
        <>
          {createPortal(
            <>
              {/* close on outside dropdown click */}
              <Overlay onClick={() => setIsOpen(false)} />
              <div ref={setPopperElement} style={{ zIndex: 500, ...styles.popper }}>
                <CalendarPickerDropdown date={date} handleSubmitDate={handleSubmitDate} />
              </div>
            </>,
            document.body
          )}
        </>
      )}
    </CalendarPickerContainer>
  );
};
